import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

const profileIcon = require('../../../../../assets/icons/edit_profile.svg').default;
const supportIcon = require('../../../../../assets/icons/support.svg').default;
const handsIcon = require('../../../../../assets/icons/hands.svg').default;
const handIcon = require('../../../../../assets/icons/hand.svg').default;

/** What the applicant is expected to do, in the order it happens. */
const steps = [
    { icon: profileIcon, text: 'Complete your profile to have more chance to choose' },
    { icon: handIcon, text: 'Be available for exams' },
    { icon: supportIcon, text: 'Be ready for Interviews' },
    { icon: handsIcon, text: 'Receive offer and hired' },
];

/** Shown in place of the job box until the applicant has a profile to match against. */
function WelcomeBox() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <span className={styles.title}>Welcome to MeritFinder</span>

            <div className={styles.content}>
                {steps.map(({ icon, text }) => <div key={text} className={styles.content_item}>
                    <div className={styles.content_item_icon}><img src={icon} alt="" /></div>
                    <span className={styles.content_item_text}>{text}</span>
                </div>)}
            </div>

            <div className={styles.button}>
                <Button text='Review your profile' onClick={() => navigate('/workspace/account')} />
            </div>
        </div>
    );
};

export default WelcomeBox;
